module.exports = __webpack_public_path__ + "static/media/spaceship_placeholder.048ab3e9.png";